import { render, staticRenderFns } from "./DiagramGender.vue?vue&type=template&id=f84668d0&"
import script from "./DiagramGender.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DiagramGender.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f84668d0')) {
      api.createRecord('f84668d0', component.options)
    } else {
      api.reload('f84668d0', component.options)
    }
    module.hot.accept("./DiagramGender.vue?vue&type=template&id=f84668d0&", function () {
      api.rerender('f84668d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/DiagramGender.vue"
export default component.exports